import React from 'react';
import Header from '../../components/Header/index'
import MyPic from '../../assets/me.jpg'
import {Picture, Paragraph, Content, Titles, SubTitles} from './styles.js'

function AboutMe(){
    return (
        <div>
            <Header/>

            <Picture backgroundImage={MyPic}/>

            <Paragraph>
                Meu nome é Alice Habitzreuter, sou de Tijucas - Santa Catarina e tenho 19 anos.
                Estou cursando Ciência da Computação Bacharelado na UNIVALI em Itajaí. <br/><br/>
                Veja abaixo minhas experiências e formações!
            </Paragraph>


            <Titles>Experiências</Titles>

            <Content>
                <h2>ASSEINFO - Analista de Suporte</h2>
                <SubTitles>04/2019 - Atualmente</SubTitles>
                <p>Responsável por atender a demandas de clientes e enteder o problema relatado, resolver os problemas de configurações e educação do sistema.
                <br/>
                Utilizo banco de dados Firebird o qual tenho um bom conhecimento.</p>
            </Content>
            

            <Titles>Formações</Titles>

            <Content>
                <h2>Ciência da Computação - UNIVALI</h2>
                <SubTitles>02/2019 - Atualmente</SubTitles>
                <p>Atualmente estou no quarto período da faculdade.<br/>
                Fiz programação orientada a objetos I em Java e Estrutura de Dados em C++.<br/>
                A matéria de banco de dados fizemos o sistema em PHP e usamos o SGBD MySQL.<br/>
                Nessa fase vou ter a matéria específica de programação web e engenharia de software.<br/></p>
            </Content>


            <Titles>Habilidades</Titles>

            <Content>
                <ul>
                    <li>Microsoft Excel - Avançado</li>
                    <li>Javascript - Intermediário</li>
                    <li>Redes de computadores - Intermediário</li>
                    <li>Inglês - Fluente</li>
                </ul>    
            </Content>
            {/*

            <h1 className='title'>Habilidades</h1>
            <div className="dados">
                <ul>
                    <li>Microsoft Excel - Avançado</li>
                    <li>Javascript - Intermediário</li>
                    <li>Redes de computadores - Intermediário</li>
                    <li>Inglês - Fluente</li>
                </ul>

            </div> */}
        </div>
    )
}

export default AboutMe;